import React from 'react';
export function LegalDoc({
  title,
  lastRevised,
  intro,
  children
}: {
  title: string;
  lastRevised: string;
  intro?: React.ReactNode;
  children: React.ReactNode;
}) {
  return <article>
      <h1 className="text-3xl font-semibold text-slate-900 tracking-tight mb-2">{title}</h1>
      <p className="text-sm text-slate-400 mb-8">Last Updated: {lastRevised}</p>
      {intro && <div className="mb-10 text-slate-600 leading-relaxed">{intro}</div>}
      <div className="space-y-10">{children}</div>
    </article>;
}
export function Section({
  number,
  title,
  children
}: {
  number: string;
  title: string;
  children: React.ReactNode;
}) {
  return <section id={`section-${number}`}>
      <h2 className="text-lg font-semibold text-slate-900 mb-3">
        <span className="text-slate-400 mr-2">{number}.</span>{' '}
        {title}
      </h2>
      <div className="text-slate-600 leading-relaxed space-y-3 [&_a]:text-slate-900 [&_a]:underline [&_a]:underline-offset-2 hover:[&_a]:text-slate-600">
        {children}
      </div>
    </section>;
}
export function P({
  num,
  children
}: {
  num?: string;
  children: React.ReactNode;
}) {
  return <p>
      {num && <span className="font-medium text-slate-800">{num} </span>}
      {children}
    </p>;
}
export function Address({
  lines
}: {
  lines: React.ReactNode[];
}) {
  return <div className="rounded-lg bg-slate-50 border border-slate-200 px-4 py-3 text-sm">
      {lines.map((line, i) => <React.Fragment key={i}>
          {line}
          {i < lines.length - 1 && <br />}
        </React.Fragment>)}
    </div>;
}
export function List({
  items
}: {
  items: React.ReactNode[];
}) {
  return <ul className="list-disc pl-5 space-y-1.5 marker:text-slate-300">
      {items.map((item, i) => <li key={i}>{item}</li>)}
    </ul>;
}
export function AlphaList({
  items
}: {
  items: React.ReactNode[];
}) {
  return <ol className="list-none pl-5 space-y-1.5">
      {items.map((item, i) => <li key={i} className="-indent-5">
          <span className="text-slate-400">({String.fromCharCode(97 + i)})</span> <span className="indent-0 inline">{item}</span>
        </li>)}
    </ol>;
}
export function Callout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 leading-relaxed">
      {children}
    </div>;
}